if (!customElements.get("vde-series-index")) {
  class VdeSeriesIndex extends HTMLElement {
    connectedCallback() {
      this.activeSeries = "all";
      this.buttons = [...this.querySelectorAll("[data-vde-filter-target]")];
      this.resultCount = this.querySelector(".vde-series-index__result-count");
      this.handleClick = this.handleClick.bind(this);
      this.applyFilter = this.applyFilter.bind(this);

      this.buttons.forEach((button) =>
        button.addEventListener("click", this.handleClick)
      );

      this.gridObserver = new MutationObserver(this.applyFilter);
      const gridContainer = document.getElementById("ProductGridContainer");

      if (gridContainer) {
        this.gridObserver.observe(gridContainer, { childList: true, subtree: true });
      }

      this.applyFilter();
    }

    disconnectedCallback() {
      this.buttons?.forEach((button) =>
        button.removeEventListener("click", this.handleClick)
      );
      this.gridObserver?.disconnect();
    }

    getProductCards() {
      return [
        ...document.querySelectorAll(
          "#product-grid product-card[data-vde-series]"
        )
      ];
    }

    handleClick(event) {
      this.activeSeries = event.currentTarget.dataset.vdeFilterTarget || "all";

      this.buttons.forEach((button) => {
        const isActive = button.dataset.vdeFilterTarget === this.activeSeries;

        if (button.closest(".vde-series-index__filter-options")) {
          button.setAttribute("aria-pressed", String(isActive));
        }
      });

      this.applyFilter();
      document.querySelector(".collection-grid-container")?.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "start"
      });
    }

    applyFilter() {
      const cards = this.getProductCards();
      let visibleCount = 0;

      cards.forEach((card) => {
        const isVisible =
          this.activeSeries === "all" ||
          card.dataset.vdeSeries === this.activeSeries;

        if (card.hidden === isVisible) {
          card.hidden = !isVisible;
        }

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.resultCount) {
        this.resultCount.textContent = `${visibleCount} ${
          visibleCount === 1 ? "design" : "designs"
        }`;
      }
    }
  }

  customElements.define("vde-series-index", VdeSeriesIndex);
}
